import { render, staticRenderFns } from "./ApplicationsOverview.vue?vue&type=template&id=c8aa399e&scoped=true&"
import script from "./ApplicationsOverview.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ApplicationsOverview.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./ApplicationsOverview.vue?vue&type=style&index=0&id=c8aa399e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8aa399e",
  null
  
)

export default component.exports